import React from 'react'
import { Container } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './style.scss'

const Header = () => {
  const {t} = useTranslation();

    return (
        <div className='main_header_outer_container'>
            <div className='main_header'>
                <Container>
                    <div className='main_header_container animate__animated animate__fadeInDown'>
                        <div className='main_header_info'>
                            <div className='main_header_title'>
                                <h1>{t("online_exhibition")}</h1>
                                <h6>{t("default_date")}</h6>
                            </div>
                            <ul>
                                <li>{t("Home_Header_List_1")}</li>
                                <li>{t("Home_Header_List_2")}</li>
                                <li>{t("Home_Header_List_3")}</li>
                            </ul>
                            <div className='links'>
                                <Link to="/exhibition" target="_blank" className='btn header-btn text-dark btn-light mx-3 mt-4 col-md-4'>{t("visit the exhibition")}</Link>
                                <Link to="/register" className='btn header-btn text-dark btn-light mt-4 col-md-4'>{t("Participate_expo")}</Link>
                            </div>
                        </div>
                        <div className='main_header_image'>
                            <img src='./assets/img/store.png' alt="header-image" />
                        </div>
                    </div>
                </Container>
            </div>
        </div>
    )
}

export default Header
